
export const cookiesUtils = {

  getCookiesAndRegion(): { idRegion: number; cookies: string } | null {
    const segments = window.location.href.split('#')[1]?.split('/');
    if (segments && segments.length > 3) {
      const idRegion = parseInt(segments[2], 10);
      const cookies = segments[3];
      return { idRegion, cookies };
    }
    return null;
  },

}
